import { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export function PageHeader({ title, subtitle, action }: PageHeaderProps) {
  return (
    <header className="bg-white/95 dark:bg-gray-800/95 backdrop-blur-md border-b border-gray-100 dark:border-gray-700/50 sticky top-0 z-40">
      <div className="px-6 py-4 flex justify-between items-center gap-4">
        <div className="min-w-0">
          <h1 className="text-xl font-bold text-gray-900 dark:text-white tracking-tight leading-snug truncate">
            {title}
          </h1>
          {subtitle && (
            <p className="text-[11px] font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-[0.08em] mt-0.5">
              {subtitle}
            </p>
          )}
        </div>
        {action && <div className="flex-shrink-0">{action}</div>}
      </div>
    </header>
  );
}
